import 'angular:locale/data:fi';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "fi";
